import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { reducerPaths } from "../../app/reducerPaths";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";
import { VITE_NODE_SERVER_BASE_URL } from "@common/utils/constants/urls/baseUrls";

export const vehicleApi = createApi({
  reducerPath: reducerPaths.vehicleApi, // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getVehicle: builder.query({
      query: ({ Vehicle_Id }) => ({
        url: `/seller/vehicle/${Vehicle_Id}`,
        method: "GET",
      }),
    }),
    setVehicleVisit: builder.mutation({
      query: ({ payload }) => {
        return {
          url: `/vehicle/visit`,
          method: "POST",
          body: payload
        }
      }
    }),
    getVehicleFrozenWalletTypeForUser: builder.query({
      query: ({ params }) => {
        return {
          url: `${VITE_NODE_SERVER_BASE_URL}/vehicle/frozenWalletType`,
          method: "GET",
          params
        }
      }
    })
  }),
});

export const {
  useGetVehicleQuery,
  useSetVehicleVisitMutation,
  useLazyGetVehicleQuery,
  useLazyGetVehicleFrozenWalletTypeForUserQuery
} = vehicleApi;